import { IconDefinition } from "./types";

const fileCertificate: IconDefinition = {
  iconName: "file-certificate",
  width: 576,
  height: 512,
  svgPathData:
    "M304 48l-128 0 0 102.6c-15.3-4.3-31.4-6.6-48-6.6l0-144 224 0 160 160 0 352-256 0 0-48 208 0 0-256-160 0 0-160zM444.1 160l-92.1-92.1 0 92.1 92.1 0zM208 419.9l0 132.1-80-40-80 40 0-132.1C18.7 396.5 0 360.4 0 320 0 249.3 57.3 192 128 192s128 57.3 128 128c0 40.4-18.7 76.5-48 99.9zM176 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "file-certificate",
  unicode: 0xf5f3,
};

export { fileCertificate };
